var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFist = function SvgFist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 92,
    viewBox: "0 0 85 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "own it",
    clipPath: "url(#clip0_3818_652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.3537 46.7007H50.2553C46.7996 46.7007 43.9868 43.8833 43.9868 40.4218V30.1178C43.9868 26.6564 46.7996 23.8389 50.2553 23.8389H51.3537C54.8094 23.8389 57.6222 26.6564 57.6222 30.1178V40.4218C57.6222 43.8833 54.8094 46.7007 51.3537 46.7007ZM50.2553 26.549C48.273 26.549 46.6657 28.159 46.6657 30.1447V40.4486C46.6657 42.4343 48.273 44.0443 50.2553 44.0443H51.3537C53.336 44.0443 54.9433 42.4343 54.9433 40.4486V30.1447C54.9433 28.159 53.336 26.549 51.3537 26.549H50.2553Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.2096 46.7008H38.8702V44.0175H40.2096C42.2991 44.0175 43.9868 42.327 43.9868 40.234V29.3397C43.9868 27.2467 42.2991 25.5562 40.2096 25.5562H39.4863C37.3968 25.5562 35.7091 27.2467 35.7091 29.3397V37.819H33.0303V29.3397C33.0303 25.7709 35.9234 22.8729 39.4863 22.8729H40.2096C43.7725 22.8729 46.6656 25.7709 46.6656 29.3397V40.234C46.6656 43.8028 43.7725 46.7008 40.2096 46.7008Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.7526 37.7921H22.0737V30.2788C22.0737 26.71 24.9669 23.812 28.5298 23.812H29.8692C33.0838 23.812 35.7091 26.4417 35.7091 29.6616H33.0302C33.0302 27.9175 31.6104 26.4953 29.8692 26.4953H28.5298C26.4403 26.4953 24.7526 28.1858 24.7526 30.2788V37.7921Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.9352 46.7008H60.7833C57.5686 46.7008 54.9434 44.0711 54.9434 40.8511V32.9622C54.9434 29.7422 57.5686 27.1125 60.7833 27.1125H61.9352C65.1498 27.1125 67.7751 29.7422 67.7751 32.9622V40.8511C67.7751 44.0711 65.1498 46.7008 61.9352 46.7008ZM60.7833 29.769C59.042 29.769 57.6222 31.1912 57.6222 32.9354V40.8243C57.6222 42.5685 59.042 43.9906 60.7833 43.9906H61.9352C63.6764 43.9906 65.0962 42.5685 65.0962 40.8243V32.9354C65.0962 31.1912 63.6764 29.769 61.9352 29.769H60.7833Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.1367 90.3852H24.4578C24.4578 80.4301 21.4039 70.9043 15.6444 62.8275C14.0103 60.5199 13.1531 57.8366 13.1531 55.0191C13.1531 51.8528 13.6621 48.7133 14.68 45.708L16.6356 39.912C17.3589 37.819 19.3144 36.3969 21.5379 36.3969H33.432C37.102 36.3969 40.0755 39.3753 40.0755 43.0515V45.1176C40.0755 47.3716 38.9504 49.3841 37.2092 50.5916C40.1559 51.9333 42.4597 54.4824 42.4597 59.3392H39.7809C39.7809 53.8116 36.3787 51.7723 27.2706 51.7723H23.4399V49.089H33.432C35.6287 49.089 37.3967 47.2911 37.3967 45.1176V43.0515C37.3967 40.8512 35.6019 39.0802 33.432 39.0802H21.5379C20.4663 39.0802 19.5287 39.751 19.1805 40.7707L17.2249 46.5666C16.2873 49.3036 15.8319 52.1479 15.8319 55.0191C15.8319 57.2731 16.5284 59.4466 17.8411 61.2712C23.9489 69.8042 27.1635 79.8935 27.1635 90.3852H27.1367Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.693 91.4049L50.8982 89.4192L52.7466 87.7287C59.7652 81.3424 63.8103 72.246 63.8103 62.747V44.0443H66.4891V62.747C66.4891 72.9973 62.1494 82.8451 54.5414 89.7144L52.693 91.4049Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M42.2724 0.628174H39.5935V10.9858H42.2724V0.628174Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.8639 4.1321L18.5439 5.47375L23.7141 14.4437L26.0341 13.1021L20.8639 4.1321Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.30207 19.0827L3.96265 21.4065L12.9177 26.5853L14.2571 24.2615L5.30207 19.0827Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.3404 40.2876H0V42.9709H10.3404V40.2876Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M61.2829 3.62792L56.1096 12.5961L58.4291 13.9385L63.6024 4.97039L61.2829 3.62792Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M79.1727 18.1151L70.2195 23.297L71.5597 25.6204L80.5129 20.4384L79.1727 18.1151Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M85 40.2876H74.6597V42.9709H85V40.2876Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 90.7767,
    fill: "white",
    transform: "translate(0 0.628174)"
  })))));
};
export default SvgFist;